import { motion, ViewportOptions } from "motion/react"
import { ReactNode } from "react"

interface SlideOnViewProps {
  children: ReactNode
  className?: string
  delay?: number
  viewport?: ViewportOptions
}

export function SlideOnView({
  children,
  className,
  delay = 0,
  viewport = {},
}: SlideOnViewProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 200 }}
      transition={{
        duration: 0.2,
        delay,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{ once: true, ...viewport }}
      className={className}
    >
      {children}
    </motion.div>
  )
}
